import {
  postPlayerState,
  getOpta,
  getOptaPicture,
  fetchTds,
} from '../../../entities/tds';

export const scope = 'TDS_WIDGET';
export const UPDATE_TEXT_AREA = 'UPDATE_TEXT_AREA';
export const RESET_GROUP = 'RESET_GROUP';

export function fetchTdsIfNeeded(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.tools.tds;

    if (!widget.info.isFetching) dispatch(fetchTds(payload, scope));
  };
}

export function updatePlayerState(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.tools.tds;

    if (!widget.info.isFetching) dispatch(postPlayerState(payload, scope));
  };
}

export function refreshOpta(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.tools.tds;

    if (!widget.info.isFetching) dispatch(getOpta(payload, scope));
  };
}

export function getOptaPic(payload) {
  return (dispatch, getState) => {
    const widget = getState().app.tools.tds;

    if (!widget.info.isFetching) dispatch(getOptaPicture(payload, scope));
  };
}

export function setGroupLocalStorage(payload) {
  return {type: UPDATE_TEXT_AREA, payload, scope};
}

export function resetGroup() {
  return {type: RESET_GROUP, scope};
}



// WEBPACK FOOTER //
// ./src/actions/app/tools/tds/listWidget.js